export default {
  message: {
    hello: 'Hello',
    products: 'Product List',
    home: 'Home',
    about: 'About',
    contact: 'Contact',
    sitemap: 'Sitemap',
    language: 'Language',
    chinese_simplified: 'Simplified Chinese',
    english: 'English',
    vietnamese: 'Vietnamese',
    chinese_traditional: 'Traditional Chinese',
    sitemapSubtitle: 'Complete index of all pages on this site for search engine crawling and user browsing',
    staticPages: 'Static Pages',
    productCategories: 'Product Categories',
    productList: 'Product List',
    allCategories: 'All Categories',
    searchProducts: 'Search products...',
    loadMore: 'Load More',
    xmlSitemap: 'XML Sitemap',
    xmlSitemapDescription: 'Standard sitemap file for search engines (sitemap.xml)',
    priority: 'Priority',
    updateFrequency: 'Update Frequency',
    productUnit: 'products',
    loading: 'Loading...',
    retry: 'Retry',
    fetchSitemapError: 'Failed to fetch sitemap, please try again later',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly'
  },
  pagination: {
    previous: 'Previous',
    next: 'Next',
    page_info: 'Page {current} / {total} ({count} records)'
  },
  product: {
    categories: {
      title: 'Product Categories',
      consumer_mosfet: 'Consumer MOSFET',
      industrial_mosfet: 'Industrial MOSFET',
      automotive_mosfet: 'Automotive MOSFET',
      power_module: 'Power Module',
      ovp: 'OVP',
      ldo: 'LDO',
      pmic: 'PMIC'
    },
    search: 'Search products...',
    no_results: 'No matching products found',
    purchase_button: 'Purchase',
    detail: {
      back: 'Back',
      basic_info: 'Basic Information',
      technical_params: 'Technical Parameters',
      documents: 'Documents',
      download_pdf: 'Download Datasheet',
      loading: 'Loading...',
      not_found: 'Product not found',
      load_error: 'Failed to load product details. Please try again later.',
      fields: {
        Title: 'Product Name',
        Package: 'Package',
        ProductStatus: 'Product Status',
        MOSFETType: 'MOSFET Type',
        Technology: 'Technology',
        IDA: 'Drain Current (A)',
        VDSMin: 'Drain-Source Voltage (V)',
        RDSon: 'On-Resistance (mΩ)',
        VGS: 'Gate-Source Voltage (V)',
        Qg: 'Total Gate Charge (nC)',
        Ciss: 'Input Capacitance (pF)',
        Coss: 'Output Capacitance (pF)',
        Crss: 'Reverse Transfer Capacitance (pF)',
        FileUrl: 'Datasheet'
      }
    },
    table: {
      model: 'Model',
      package: 'Package',
      product_status: 'Product Status',
      mosfet_type: 'MOSFET Type',
      technology: 'Technology',
      current: 'Current',
      voltage: 'Voltage',
      datasheet: 'Datasheet',
      view_pdf: 'View PDF',
      actions: 'Actions'
    }
  },
  about: {
    company_intro: 'Company Introduction',
    company_desc: '765.info specializes in providing high-performance, high-reliability power semiconductor solutions. With advanced chip design technology and mature manufacturing processes, we offer quality core components such as MOSFETs, DC-DC power management ICs, and AC-DC conversion chips for industrial automation, new energy, smart home, consumer electronics, and other fields, helping customers improve product efficiency and reduce system costs.',
    
    core_advantages: 'Core Advantages',
    advantage_direct_supply_title: 'Direct Factory Supply',
    advantage_direct_supply_desc: 'Deep cooperation with factory partners ensures authentic products with significant price advantages.',
    advantage_tech_leadership_title: 'Technical Leadership',
    advantage_tech_leadership_desc: 'Providing power devices with advanced processes such as VD-Trench, SJ-MOS, and SGT-MOS to meet high-efficiency and low-loss requirements.',
    advantage_solution_support_title: 'Solution Support',
    advantage_solution_support_desc: 'Offering reference designs for motor drives, power management, LED lighting, and more to shorten customer development cycles.',
    advantage_quick_response_title: 'Quick Response',
    advantage_quick_response_desc: 'In-stock inventory and flexible supply chain supporting both small-batch samples and large-scale procurement.',
    
    main_products: 'Main Products',
    mosfet_series_title: 'MOSFET Series',
    mosfet_low_voltage: 'Medium-Low Voltage MOS (20V-200V): Suitable for power tools and lithium battery protection.',
    mosfet_high_voltage: 'High Voltage MOS (500V-650V): Used in industrial power supplies and photovoltaic inverters.',
    dcdc_chips_title: 'DC-DC Buck Converter Chips',
    dcdc_chips_desc: 'Series (40V/2A), series (5V/3A), replacing imported brands.',
    acdc_chips_title: 'AC-DC Conversion Chips',
    acdc_chips_desc: 'Solutions supporting 220V to 5V/12V applications for home appliances, smart meters, etc.',
    custom_services_title: 'Custom Services',
    custom_services_desc: 'Providing technical support for chip selection, circuit optimization, modular design, and more.',
    
    service_areas: 'Service Areas',
    area_industrial_control: 'Industrial Control (Motor Drives, PLC)',
    area_new_energy: 'New Energy (Energy Storage, EV Charging Stations)',
    area_consumer_electronics: 'Consumer Electronics (Fast Charging, LED Lighting)',
    area_smart_home: 'Smart Home (Home Appliances, Security Devices)',
    
    mission_vision: 'Mission and Vision',
    mission_vision_desc: 'We aim to "make efficient power devices accessible" by combining professional technical strength with our localized services to provide stable and innovative semiconductor solutions for our customers.'
  },
  contact: {
    info_title: 'Contact Information',
    address_title: 'Address',
    address_value: 'Room 2305, Jinhao Building, No.109 Guangshen Road (Fuyong Section), Fenghuang Community, Fuyong Street, Baoan District, Shenzhen, China',
    phone_title: 'Phone',
    phone_value: '+86 139-8626-3349',
    email_title: 'Email',
    hours_title: 'Business Hours',
    hours_value: 'Monday to Friday, 9:00 AM - 6:00 PM',
    form_title: 'Contact Form',
    name: 'Name',
    name_placeholder: 'Please enter your name',
    email: 'Email',
    email_placeholder: 'Please enter your email',
    subject: 'Subject',
    subject_placeholder: 'Please enter the subject',
    message: 'Message',
    message_placeholder: 'Please enter your message',
    submit: 'Submit',
    form_success: 'Your message has been successfully submitted. We will contact you soon!',
    location: 'Our Location',
    map_placeholder: 'Map loading...',
    email_note: 'After submission, our team will receive your message',
    errorMessage: 'Failed to send email. Please try again later.'
  }
}